import {
	Component,
	Input,
	OnInit
}                       from '@angular/core';
import {
	ISvgConfig,
	SvgSizeEnum,
	SvgStateEnum,
	SvgTypeEnum
}                       from '@app/shared/components/svg/svg.model';
import { getSvgConfig } from '@shared/components/svg/svg.config';


@Component( {
	selector: 'app-svg',
	templateUrl: './svg.component.html',
	styleUrls: [ './svg.component.scss' ]
} )

export class SvgComponent implements OnInit {

	private _size: SvgSizeEnum = SvgSizeEnum.MEDIUM;

	private _type: SvgTypeEnum = SvgTypeEnum.BUSINESS_PREMISES;

	private _strokeable = true;

	private _fillable = false;

	private _stateArray?: SvgStateEnum[] = [];

	viewBox = '0 0 32 32';

	get type(): SvgTypeEnum {
		return this._type;
	}

	@Input() set type( type: SvgTypeEnum ) {
		this._type = type;
	}

	get size(): SvgSizeEnum {
		return this._size;
	}

	@Input() set size( size: SvgSizeEnum ) {
		this._size = size;
	}

	get stateArray(): SvgStateEnum[] {
		return this._stateArray;
	}

	@Input() set stateArray( stateArray: SvgStateEnum[] ) {
		this._stateArray = stateArray;
	}

	get strokeable(): boolean {
		return this._strokeable;
	}

	@Input() set strokeable( strokeable: boolean ) {
		this._strokeable = strokeable;
	}

	get fillable(): boolean {
		return this._fillable;
	}

	@Input() set fillable( fillable: boolean ) {
		this._fillable = fillable;
	}

	@Input() fillColor: string;

	@Input() strokeColor: string;

	@Input() svgStyleClass = '';

	config: ISvgConfig;

	svgTypes = SvgTypeEnum;

	constructor() {}

	ngOnInit(): void {
		this.config = getSvgConfig( this.type );
		const x = this.config?.dimensions?.viewBoxX ?? '0';
		const y = this.config?.dimensions?.viewBoxY ?? '0';
		const w = this.config?.dimensions?.viewBoxWidth;
		const h = this.config?.dimensions?.viewBoxHeight;

		this.viewBox = `${ x } ${ y } ${ w } ${ h }`;
	}
}
